import { render, staticRenderFns } from "./courseCell.vue?vue&type=template&id=07fff2a6"
import script from "./courseCell.vue?vue&type=script&lang=js"
export * from "./courseCell.vue?vue&type=script&lang=js"
import style0 from "./courseCell.vue?vue&type=style&index=0&id=07fff2a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports